export default{sources:{avif:"__VITE_ASSET__BF_PaAlN__ 400w",webp:"__VITE_ASSET__BpO3Mgk___ 400w"},img:{src:"__VITE_ASSET__CxFmcXJ1__",w:400,h:267}};